/* eslint-disable react/prop-types */
/* eslint-disable no-extra-boolean-cast */
import React from "react";
import PropTypes from "prop-types";
import Trash from "../../../assets/svg/trash";
import { Button, Checkbox, Form, Modal, Space, Tooltip, Upload } from "antd";
import {
  setCheckBoxSelected as setExternalCheckBoxSelected,
  setEditExhibitionId,
  setEditOnlyStand,
  setEditStandId,
  setIsEditMode
} from "../../../store/exhibitionSlice";
import { useSelector } from "react-redux";
import TextArea from "antd/lib/input/TextArea";
import ImagePreview from "../../ImagePreview/ImagePreview";
import { useState } from "react";
import { exhibitionAPI, uploadsAPI } from "../../../api/api";
import dayjs from "dayjs";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Edit from "../../../assets/svg/Edit";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import s from "./secondary-table-row.module.less";
import { useEffect } from "react";

const SecondaryTableRow = ({
  isOnlyExhibition,
  stand = {},
  item,
  t,
  form,
  editindExhibition,
  OnlyLatinLettersTextInput,
  handleDelete,
  handleOpenModal,
  isStandEditable = false,
  passageDiagram,
  onFinish,
  setPassageDiagram,
  logo,
  setLogo,
  setIsLogoDeleted,
  isLogoDeleted,
  setIsImageDeleted = () => {},
  errors,
  onModerationClick,
  setErrors,
  checkBoxSelected,
  setCheckboxSelected,
  isImageDeleted = false,
  handleEdit,
  isUserExhibition,
  isArchive
}) => {
  const { isEditMode, editStandId, editExhibitionId, editOnlyStand } = useSelector(
    (state) => state.exhibitions
  );
  const { isAdmin } = useSelector((state) => state.auth);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [logoPreviewOpen, setLogoPreviewOpen] = useState(false);
  const { pathname } = useLocation();

  const initialCheckbox = {
    isPrivate: item.isPrivate,
    isVisible: stand.isVisible
  };

  const [modalOpen, setModalOpen] = useState(false);

  const isEditIconShow =
    editExhibitionId === item.id
      ? isEditMode && (editExhibitionId === item.id || editStandId === stand?.id)
      : false;

  const itemPassageDiagram = item?.stands?.[0]?.passageDiagram;

  const itemLogo = item?.logo;

  useEffect(() => {
    dispatch(setExternalCheckBoxSelected(checkBoxSelected));
  }, [checkBoxSelected]);

  useEffect(() => {
    if (editExhibitionId !== item.id) {
      setCheckboxSelected(initialCheckbox);
    }
  }, [editExhibitionId, item.id]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (itemPassageDiagram && isStandEditable) {
      setPassageDiagram(itemPassageDiagram);
    }
  }, [itemPassageDiagram, isStandEditable]);

  useEffect(() => {
    if (itemLogo && isStandEditable) {
      setLogo(itemLogo);
    }
  }, [itemLogo, isStandEditable]);

  useEffect(() => {
    setCheckboxSelected((prev) => {
      return {
        ...prev,
        isPrivate: item.isPrivate,
        isVisible: stand.isVisible
      };
    });
  }, [item.isPrivate, stand.isVisible]);

  const uploadImg = async (data, isLogo) => {
    const formData = new FormData();
    formData.append("file", data.file, data.file.type.replace("/", "."));
    formData.append("originalname", data.file.name);
    const uploadedImage = await (await uploadsAPI.uploadImage(formData)).data.filename;
    if (isLogo) {
      setLogo(uploadedImage);
      form.setFieldsValue({ logo: uploadedImage });
      isAdmin && form.setFieldsValue({ isLogoDeleted: "false" });
      setIsLogoDeleted(false);
    } else {
      setPassageDiagram(uploadedImage);
      setIsImageDeleted(false);
    }
  };

  const normalizeFile = (event) => {
    if (Array.isArray(event)) {
      return event;
    }
    return event && event.fileList;
  };
  const beforeUpload = (file, isLogo) => {
    if (file.size / 1024 > 5024) {
      clearImage();
      setErrors((prev) => ({
        ...prev,
        ...(isLogo ? { logo: true } : { passageDiagram: true })
      }));
      return false;
    } else {
      setErrors((prev) => ({
        ...prev,
        ...(isLogo ? { logo: false } : { passageDiagram: false })
      }));
    }
  };
  const clearImage = (event, isLogo) => {
    if (isLogo) {
      setIsLogoDeleted(true);
      setLogo("");
      console.log(form);
      form.setFieldsValue({ logo: "" });
      isAdmin && form.setFieldsValue({ isLogoDeleted: "true" });
    } else {
      setIsImageDeleted(true);
      setPassageDiagram("");
    }
  };

  const closeImagePreview = (isLogo) =>
    isLogo ? setLogoPreviewOpen(false) : setImagePreviewOpen(false);
  const openImagePreview = (isLogo) =>
    isLogo ? setLogoPreviewOpen(true) : setImagePreviewOpen(true);

  const handleModalSubmit = () => {
    setModalOpen(false);
  };

  const handleIsVisible = async ({ target: checked }) => {
    if (checkBoxSelected.isPrivate && checked.checked) {
      await exhibitionAPI.changeExhibitionPrivacy(item.id, false);
      await exhibitionAPI.changeExhibitionVisibility(stand.id, checked.checked);
    } else {
      await exhibitionAPI.changeExhibitionVisibility(stand.id, checked.checked);
    }
    setCheckboxSelected((prevState) => {
      return {
        ...prevState,
        isVisible: checked.checked,
        isPrivate: false
      };
    });
  };

  const handleIsPrivate = async ({ target: checked }) => {
    try {
      if (checkBoxSelected.isVisible && checked.checked) {
        await exhibitionAPI.changeExhibitionVisibility(stand.id, false);
        await exhibitionAPI.changeExhibitionPrivacy(item.id, checked.checked);
      } else {
        await exhibitionAPI.changeExhibitionPrivacy(item.id, checked.checked);
      }
      setCheckboxSelected((prevState) => {
        return {
          ...prevState,
          isVisible: false,
          isPrivate: checked.checked
        };
      });
    } catch (e) {
      if (e.response.status === 403) {
        setModalOpen(true);
      }
    }
  };

  return (
    <div
      key={`${stand.id}-1`}
      className={s.stand}
      style={{ borderLeft: isOnlyExhibition && "none" }}
    >
      {!isAdmin && <div className={`${s.cell2} ${s.leftSide}`}></div>}
      {!isOnlyExhibition && (
        <div className={s.standLeft}>
          <div key={`${stand.id}-2`}>
            <div style={{ height: 54, alignItems: "center" }} className={`${s.cell} ${s.premid}`}>
              {t("exhibitionLogo", { ns: "CreateExhibitionPanel" })}:
            </div>
            <div className={`${s.cell2} ${s.premid} ${s.halfPadding}`}>
              {!isEditMode && !isStandEditable ? (
                itemLogo &&
                itemLogo?.length && (
                  <>
                    <ImagePreview
                      isOpen={logoPreviewOpen}
                      closePreview={() => closeImagePreview(true)}
                      openPreview={() => openImagePreview(true)}
                      imageUrl={`${item?.logo}`}
                    />
                  </>
                )
              ) : (
                <Form.Item name={"logo"} valuePropName="fileList" getValueFromEvent={normalizeFile}>
                  {isEditMode && isStandEditable && isUserExhibition ? (
                    <>
                      {!isLogoDeleted && logo ? (
                        <>
                          <ImagePreview
                            isOpen={logoPreviewOpen}
                            closePreview={() => closeImagePreview(true)}
                            openPreview={() => openImagePreview(true)}
                            imageUrl={`${logo}`}
                          />
                          <p className={s.deleteText} onClick={() => clearImage(_, true)}>
                            {t("delete", { ns: "CreateExhibitionPanel" })}
                          </p>
                        </>
                      ) : (
                        <Upload
                          maxCount={1}
                          multiple={false}
                          accept=".jpg,.jpeg"
                          showUploadList={false}
                          beforeUpload={(file) => beforeUpload(file, true)}
                          customRequest={(data) => uploadImg(data, true)}
                        >
                          <p className={`${s.uploadText} ${errors.logo ? s.error : ""}`}>
                            {t("uploadSchema", { ns: "CreateExhibitionPanel" })}
                          </p>
                        </Upload>
                      )}
                    </>
                  ) : (
                    <>
                      {itemLogo && isEditMode && !isUserExhibition ? (
                        <ImagePreview
                          isOpen={logoPreviewOpen}
                          closePreview={() => closeImagePreview(true)}
                          openPreview={() => openImagePreview(true)}
                          imageUrl={`${itemLogo}`}
                        />
                      ) : (
                        (!logo && isEditMode && !isAdmin && !isUserExhibition) ||
                        (editOnlyStand && (
                          <Upload
                            maxCount={1}
                            multiple={false}
                            accept=".jpg,.jpeg"
                            showUploadList={false}
                            beforeUpload={(file) => beforeUpload(file, true)}
                            customRequest={(data) => uploadImg(data, true)}
                          >
                            <p className={`${s.uploadText} ${errors.logo ? s.error : ""}`}>
                              {t("uploadSchema", { ns: "CreateExhibitionPanel" })}
                            </p>
                          </Upload>
                        ))
                      )}
                    </>
                  )}
                </Form.Item>
              )}
            </div>
          </div>
          <div>
            <div className="d-flex">
              <div className={`${s.cell} ${s.premid}`} style={{ height: 54, alignItems: "center" }}>
                {t("table.boothNumber")}:
              </div>
            </div>
            <div className="d-flex">
              <div className={`${s.cell2} ${s.premid}`}>
                {!isEditMode || !isStandEditable ? (
                  <p>{stand.boothNumber}</p>
                ) : (
                  <Form.Item
                    name={"boothNumber"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <TextArea
                      className={s.textInput}
                      defaultValue={stand.boothNumber}
                      placeholder={t("enterboothNumber", { ns: "CreateExhibitionPanel" })}
                      onChange={(e) => {
                        !isAdmin
                          ? OnlyLatinLettersTextInput(
                              e.target.value,
                              "boothNumber",
                              form,
                              true,
                              null,
                              null,
                              true
                            )
                          : e.target.value;
                      }}
                    />
                  </Form.Item>
                )}
              </div>
            </div>
          </div>
          <div key={`${stand.id}-3`}>
            <div style={{ height: 54, alignItems: "center" }} className={`${s.cell} ${s.premid}`}>
              {t("table.schemaToStand")}:
            </div>
            <div className={`${s.cell2} ${s.premid} ${s.halfPadding}`}>
              {!isEditMode && !isStandEditable ? (
                stand?.passageDiagram &&
                stand?.passageDiagram.length && (
                  <>
                    <ImagePreview
                      isOpen={imagePreviewOpen}
                      closePreview={() => closeImagePreview(false)}
                      openPreview={() => openImagePreview(false)}
                      imageUrl={`${stand?.passageDiagram}`}
                    />
                  </>
                )
              ) : (
                <Form.Item
                  name={["stand", "passageDiagram"]}
                  valuePropName="fileList"
                  getValueFromEvent={normalizeFile}
                >
                  {isEditMode && isStandEditable && passageDiagram ? (
                    <>
                      {!isImageDeleted && passageDiagram ? (
                        <>
                          <ImagePreview
                            isOpen={imagePreviewOpen}
                            closePreview={() => closeImagePreview(false)}
                            openPreview={() => openImagePreview(false)}
                            imageUrl={`${passageDiagram}`}
                          />
                          <p className={s.deleteText} onClick={clearImage}>
                            {t("delete", { ns: "CreateExhibitionPanel" })}
                          </p>
                        </>
                      ) : (
                        <Upload
                          maxCount={1}
                          multiple={false}
                          accept=".jpg,.jpeg"
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                          customRequest={(data) => uploadImg(data)}
                        >
                          <p className={`${s.uploadText} ${errors.passageDiagram ? s.error : ""}`}>
                            {t("uploadPassageToStandScheme")}
                          </p>
                        </Upload>
                      )}
                    </>
                  ) : (
                    <>
                      {stand?.passageDiagram && isEditMode && !isStandEditable ? (
                        <ImagePreview
                          isOpen={imagePreviewOpen}
                          closePreview={() => closeImagePreview(false)}
                          openPreview={() => openImagePreview(false)}
                          imageUrl={`${stand?.passageDiagram}`}
                        />
                      ) : (
                        !passageDiagram &&
                        isEditMode &&
                        isStandEditable && (
                          <Upload
                            maxCount={1}
                            multiple={false}
                            accept=".jpg,.jpeg"
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            customRequest={(data) => uploadImg(data)}
                          >
                            <p
                              className={`${s.uploadText} ${errors.passageDiagram ? s.error : ""}`}
                            >
                              {t("uploadPassageToStandScheme")}
                            </p>
                          </Upload>
                        )
                      )}
                    </>
                  )}
                </Form.Item>
              )}
            </div>
          </div>
        </div>
      )}
      <div
        className={s.standRight}
        style={{
          borderLeft: isAdmin && !pathname.includes("/admin-panel/users-list") ? "none" : "1px"
        }}
      >
        {isOnlyExhibition && (
          <div key={`${stand.id}-2`}>
            <div
              style={{ height: 54, alignItems: "center" }}
              className={`${s.exhibitionLogo} ${s.cell} ${s.mid}`}
            >
              {t("exhibitionLogo", { ns: "CreateExhibitionPanel" })}:
            </div>
            <div className={`${s.cell2} ${s.premid} ${s.halfPadding}`}>
              {!isEditMode ? (
                itemLogo &&
                itemLogo?.length && (
                  <>
                    <ImagePreview
                      isOpen={logoPreviewOpen}
                      closePreview={() => closeImagePreview(true)}
                      openPreview={() => openImagePreview(true)}
                      imageUrl={`${item?.logo}`}
                    />
                  </>
                )
              ) : (
                <Form.Item name={"logo"} valuePropName="fileList" getValueFromEvent={normalizeFile}>
                  {isEditMode && logo ? (
                    <>
                      {!isLogoDeleted && logo ? (
                        <>
                          <ImagePreview
                            isOpen={logoPreviewOpen}
                            closePreview={() => closeImagePreview(true)}
                            openPreview={() => openImagePreview(true)}
                            imageUrl={`${logo}`}
                          />
                          <p className={s.deleteText} onClick={() => clearImage(_, true)}>
                            {t("delete", { ns: "CreateExhibitionPanel" })}
                          </p>
                        </>
                      ) : (
                        <Upload
                          maxCount={1}
                          multiple={false}
                          accept=".jpg,.jpeg,.png"
                          showUploadList={false}
                          beforeUpload={(file) => beforeUpload(file, true)}
                          customRequest={(data) => uploadImg(data, true)}
                        >
                          <p className={`${s.uploadText} ${errors.logo ? s.error : ""}`}>
                            {t("uploadSchema", { ns: "CreateExhibitionPanel" })}
                          </p>
                        </Upload>
                      )}
                    </>
                  ) : (
                    <>
                      {!isLogoDeleted && itemLogo && isEditMode ? (
                        <>
                          <ImagePreview
                            isOpen={logoPreviewOpen}
                            closePreview={() => closeImagePreview(true)}
                            openPreview={() => openImagePreview(true)}
                            imageUrl={`${itemLogo}`}
                          />
                          {isOnlyExhibition && item.id === editExhibitionId && (
                            <p className={s.deleteText} onClick={() => clearImage(_, true)}>
                              {t("delete", { ns: "CreateExhibitionPanel" })}
                            </p>
                          )}
                        </>
                      ) : (
                        !logo &&
                        isEditMode && (
                          <Upload
                            maxCount={1}
                            multiple={false}
                            accept=".jpg,.jpeg,.png"
                            showUploadList={false}
                            beforeUpload={(file) => beforeUpload(file, true)}
                            customRequest={(data) => uploadImg(data, true)}
                          >
                            <p className={`${s.uploadText} ${errors.logo ? s.error : ""}`}>
                              {t("uploadSchema", { ns: "CreateExhibitionPanel" })}
                            </p>
                          </Upload>
                        )
                      )}
                    </>
                  )}
                </Form.Item>
              )}
            </div>
          </div>
        )}
        <div
          className={s.standDescription}
          style={{
            width: "calc(100% - 160px)"
          }}
        >
          {isEditMode && ((isOnlyExhibition && item.id === editExhibitionId) || isStandEditable) ? (
            <Form.Item
              name={"description"}
              rules={[
                {
                  required: true,
                  message: ""
                }
              ]}
            >
              <TextArea
                className={s.textInput}
                style={{ minHeight: 215 }}
                defaultValue={stand?.description || item?.description}
                placeholder={t("description", { ns: "CreateExhibitionPanel" })}
                onChange={(e) =>
                  !isAdmin
                    ? OnlyLatinLettersTextInput(
                        e.target.value,
                        "description",
                        form,
                        true,
                        /[^a-z\s\d-@,.?!_/:;’©®™°…‾´<>±⁄≤≥≈€¢£$•&«»″*–—#%+=()'"^\[\]]/gi,
                        null,
                        true
                      )
                    : e.target.value
                }
              />
            </Form.Item>
          ) : (
            <p style={{ whiteSpace: "pre-line" }}>{stand?.description || item?.description}</p>
          )}
        </div>
        <div
          className={`${s.controls} ${s.big}`}
          style={{ width: isAdmin && !pathname.includes("/admin-panel/users-list") ? 256 : 180 }}
        >
          {!isOnlyExhibition && (
            <div className={s.checkboxes}>
              {!isOnlyExhibition && (
                <Space>
                  <Form.Item
                    className={s.formItem}
                    name={["stand", "isVisible"]}
                    valuePropName="checked"
                    rules={[
                      {
                        required: editStandId === stand.id,
                        message: ""
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const isVisible = getFieldValue(["exhibition", "isPrivate"]);
                          if (!Boolean(value) && isVisible) {
                            return Promise.resolve();
                          } else if (Boolean(value) && !isVisible) {
                            return Promise.resolve();
                          } else if (Boolean(value)) {
                            return Promise.resolve();
                          } else {
                            return Promise.resolve();
                          }
                        }
                      })
                    ]}
                  >
                    <Space>
                      <Checkbox
                        className="small"
                        style={{ borderColor: "red" }}
                        defaultChecked={stand.isVisible}
                        ariaChecked="isVisible"
                        checked={checkBoxSelected.isVisible}
                        onChange={handleIsVisible}
                      />
                      <span>{t("table.isVisible")}</span>
                      <Tooltip
                        placement="bottomLeft"
                        title={
                          isUserExhibition
                            ? t("visibility", { ns: "CreateExhibitionPanel" })
                            : t("visibility_v2", { ns: "CreateExhibitionPanel" })
                        }
                      >
                        <QuestionCircleOutlined
                          style={{
                            position: "relative",
                            cursor: "help",
                            alignSelf: "end",
                            marginBottom: 0,
                            color: "#474747"
                          }}
                        />
                      </Tooltip>
                    </Space>
                  </Form.Item>
                </Space>
              )}
              <Space>
                <Form.Item
                  className={s.formItem}
                  name={["exhibition", "isPrivate"]}
                  valuePropName="checked"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const isVisible = getFieldValue(["stand", "isVisible"]);
                        if (!Boolean(value) && isVisible) {
                          return Promise.resolve();
                        } else if (Boolean(value) && !isVisible) {
                          return Promise.resolve();
                        } else if (Boolean(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.resolve();
                        }
                      }
                    })
                  ]}
                >
                  <Space>
                    <Checkbox
                      className="small"
                      style={{ borderColor: "red" }}
                      defaultChecked={item.isPrivate}
                      checked={checkBoxSelected.isPrivate}
                      ariaChecked="isPrivate"
                      onChange={handleIsPrivate}
                    />
                    <span>{t("table.isPrivate")}</span>
                    <Tooltip
                      placement="bottomLeft"
                      title={
                        isUserExhibition
                          ? t("private", { ns: "CreateExhibitionPanel" })
                          : t("private_v2", { ns: "CreateExhibitionPanel" })
                      }
                    >
                      <QuestionCircleOutlined
                        style={{
                          position: "relative",
                          cursor: "help",
                          alignSelf: "end",
                          marginBottom: 0,
                          color: "#474747"
                        }}
                      />
                    </Tooltip>
                  </Space>
                </Form.Item>
              </Space>
            </div>
          )}
          <div
            className={s.actions}
            style={
              isOnlyExhibition || isEditMode
                ? {
                    marginTop: "auto",
                    borderTop: editExhibitionId === item.id ? "1px solid #e8edf0" : "none"
                  }
                : { width: isEditMode ? 169 : 177, marginTop: "auto" }
            }
          >
            <div className={s.wrap}>
              {!isArchive && (
                <>
                  {!isEditIconShow && (
                    <Tooltip
                      placement="topRight"
                      title={t("editTooltip")}
                      align={{ offset: [15, 0] }}
                    >
                      <div style={{ height: 17 }}>
                        <Edit
                          onClick={
                            !isEditMode
                              ? () => {
                                  if (!isAdmin && item.moderationStatusId === 1) {
                                    handleOpenModal("EDIT_MODE_ONMODER");
                                  } else if (!isAdmin && item.moderationStatusId === 3) {
                                    handleOpenModal("EDIT_MODE_ACCEPTED");
                                  } else if (!isAdmin) {
                                    handleOpenModal("EDIT_MODE_V2");
                                  } else {
                                    handleOpenModal("EDIT_MODE");
                                  }
                                  if (pathname.includes("/admin-panel/users-list")) {
                                    dispatch(setEditOnlyStand(true));
                                  }
                                  dispatch(setEditExhibitionId(item.id));
                                  dispatch(setIsEditMode(false));
                                  dispatch(setEditStandId(stand.id));
                                }
                              : () => {
                                  if (item.id !== editExhibitionId) {
                                    handleOpenModal("FINISH_EDITING");
                                    handleEdit({
                                      exhibitionId: item.id,
                                      standId: item?.stands?.[0].id
                                    });
                                    setCheckboxSelected(initialCheckbox);
                                  }
                                }
                          }
                        />
                      </div>
                    </Tooltip>
                  )}
                  {/* {!isEditMode &&
                  ((isAdmin && !pathname.includes("/admin-panel/users-list")) || !isAdmin) ? (
                    <Tooltip placement="left" title={isEditIconShow ? t("saveAndContinue") : ""}>
                      <button
                        className={`${s.save} ${!isEditIconShow ? s.disabled : ""}`}
                        type={!isEditIconShow ? "button" : "submit"}
                        disabled={!isEditIconShow}
                      >
                        S
                      </button>
                    </Tooltip>
                  ) : (
                    ""
                  )} */}
                  {/* {!isEditMode && (
                    <Tooltip placement="left" title={isEditIconShow ? t("sendModerationBtn") : ""}>
                      <button
                        className={`${s.moderate} ${!isEditIconShow ? s.disabled : ""}`}
                        type={"button"}
                        disabled={!isEditIconShow}
                        onClick={() => onModerationClick()}
                      >
                        {isAdmin ? "P" : "M"}
                      </button>
                    </Tooltip>
                  )} */}
                </>
              )}
              <Tooltip placement="top" title={t("deleteTooltip")}>
                <div style={{ height: 20 }}>
                  <Trash onClick={() => handleDelete(stand, item)} stroke={"#222222"} />
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <Modal
        width={520}
        visible={modalOpen}
        onCancel={handleModalSubmit}
        onOk={handleModalSubmit}
        closable={true}
        footer={[
          <Button onClick={() => handleModalSubmit()} className={`btn btn_v2`} key={2}>
            {t("OK")}
          </Button>
        ]}
      >
        <p>{t("modalErrors.CANT_CHANGE_PRIVACY", { ns: "FS100-MyExhibitions" })}</p>
      </Modal>
    </div>
  );
};

export default SecondaryTableRow;

SecondaryTableRow.propTypes = {
  isOnlyExhibition: PropTypes.string,
  t: PropTypes.func,
  form: PropTypes.object,
  OnlyLatinLettersTextInput: PropTypes.func,
  passageDiagram: PropTypes.string,
  handleDelete: PropTypes.func,
  stand: PropTypes.object,
  item: PropTypes.object,
  setPassageDiagram: PropTypes.func,
  handleOpenModal: PropTypes.func,
  clearImage: PropTypes.func,
  isStandEditable: PropTypes.bool,
  isImageDeleted: PropTypes.bool,
  setIsImageDeleted: PropTypes.func,
  handleEdit: PropTypes.func
};
